export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/article_to_video.b8fedeb.svg";